import { HubSection } from "./RecordPages.js";

export function ClientHome() {
	return (
		<div className="card">
			<h2>Dashboard</h2>
			<p className="sub">
				Projects, work progress, and financial summaries for your organisation appear here.
			</p>
		</div>
	);
}

export function ClientWork() {
	return <HubSection id="work-orders" />;
}

export function ClientCalendar() {
	return <HubSection id="calendar" />;
}

export function ClientQuotations() {
	return <HubSection id="quotations" />;
}

export function ClientInvoices() {
	return <HubSection id="invoices" />;
}
